export default __webpack_public_path__ + "static/Security-acc289dfdcb8adc90b58e79c3f62f547.svg";